import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button, Stack } from '@mui/material';

import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

interface IStakingSectionFooterProps {
  children?: ReactNode;
  stakingLink: string;
}

export function StakingSectionFooter({
  children,
  stakingLink,
}: IStakingSectionFooterProps): ReactElement {
  const { keys, t } = useTranslation(translation);

  return (
    <Stack
      alignItems={{ sm: 'center' }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      spacing={6}
    >
      {children}

      <Button
        fullWidth
        component={Link}
        sx={{ maxWidth: { sm: 144 } }}
        to={stakingLink}
        variant="outlined"
      >
        {t(keys.stake)}
      </Button>
    </Stack>
  );
}
